var map = {
	"./ar/translation.json": [
		1679,
		679
	],
	"./en/translation.json": [
		1996,
		996
	],
	"./es/translation.json": [
		4107,
		107
	],
	"./fr/translation.json": [
		5387,
		387
	],
	"./hi/translation.json": [
		5305,
		305
	],
	"./id/translation.json": [
		9964,
		964
	],
	"./ms/translation.json": [
		3733,
		733
	],
	"./pt/translation.json": [
		6362,
		362
	],
	"./th/translation.json": [
		7121,
		121
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8539;
module.exports = webpackAsyncContext;